import script from "./VuetablePaginationInfoMixin.vue?vue&type=script&lang=js"
export * from "./VuetablePaginationInfoMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__